<tec-confirmation-layout title="¡Muchas gracias por cumplimentar el formulario!" [subtitle]="subtitle">
	<ng-container>
		<tec-spinner
			*ngIf="isLoading"
			[show]="isLoading"
			[img]="'assets/images/pensumo-logo.svg'"
		></tec-spinner>

		<tec-tile style="white-space: pre-line" type="default" title="Firma manuscrita con empleo de datos biométricos" icon="icon-sign">
			<span class="neutral">Te enviaremos un correo electrónico con el contrato para que lo revises y lo firmes. Puedes proceder a la firma bien con tu ordenador o a través de tu dispositivo móvil escaneando el código QR que te aparecerá en la pantalla.</span>
			<div>
				<span>INFORMACIÓN BÁSICA DE PROTECCIÓN DE DATOS</span>
				<p>
					El empleo de este método de firma implica que en “Pensumo, Pensión por Consumo, S.L.”, como entidad legalmente responsable, tratemos tus datos personales identificativos (nombre, apellidos, número de Documento Nacional de Identidad), de contacto (correo electrónico profesional de contacto), y datos de firma de documentación (hash alfanumérico de la firma, sello de tiempo, clave pública, IP del dispositivo empleado, sistema operativo del dispositivo, y navegador empleado en el dispositivo), con la finalidad de gestionar y permitir la firma de la documentación contractual necesaria para la formalización del alta del comercio al que representas comercio asociado en la Plataforma.<br /><br />
					Adicionalmente, <span class="bold">en caso de que lo consientas expresamente, en el curso de este proceso de firma trataremos tus datos biométricos (trazo, coordenadas y presión) contribuyendo de este modo a incrementar la fiabilidad de su autenticidad y la seguridad del proceso, así como a evitar situaciones fraudulentas en la contratación.<br /><br />
					El tratamiento de tus datos personales biométricos se llevará a cabo única y exclusivamente en caso de que lo consientas conforme a la autorización que te presentamos más abajo.</span><br /><br />
					Ten en cuenta que el proceso de firma se produce sobre un dispositivo (i) de tu titularidad, o (ii) de titularidad del comercio al que representas, por lo que la captura de estos datos biométricos estará condicionada a las capacidades técnicas del mismo.<br /><br />
					<span class="bold">Por supuesto, si prefieres firmar sin empleo de datos biométricos, ponemos a tu disposición una alternativa basada en el envío de un código de un solo uso a través de SMS. Para acceder a la misma, únicamente tienes que seleccionar “NO” en la autorización presentada a continuación:</span>
				</p>
			</div>

			<tec-tile styling="highlight">
				<span class="neutral small"><b>Autorizo a “Pensumo, Pensión por Consumo, S.L.”</b> para que proceda al tratamiento de mis datos personales biométricos (trazo, coordenadas y presión) durante el proceso de firma de la documentación contractual necesaria para la formalización del alta del comercio al que represento como comercio asociado en la Plataforma.</span>

				<tec-toggle-accept
					[options]="[
						{ id: 'yes', label: 'Si' },
						{ id: 'no', label: 'No' }
					]"
					(changeValue)="valueChange($event, 'switchAutorizacion')"
				>
				</tec-toggle-accept>
			</tec-tile>

			<span>Tienes derecho a solicitar el acceso, la rectificación, la supresión y otros derechos que te reconozca en cada momento la legislación vigente. Puedes consultar información adicional sobre el tratamiento de tus datos personales, en especial sobre el ejercicio de tus derechos, en el <a href="https://media.ibercaja.net/pensumo/gdpr/comercios-personas-fisicas-contacto_v3.pdf">Documento de Información Adicional de Protección de Datos</a>.</span>
		</tec-tile>
		<tec-tile
			*ngIf="switchAutorizacion === false"
			style="white-space: pre-line"
			type="default"
			title="Firma por código SMS"
			icon="icon-mail"
		>
			<span class="neutral">Te enviaremos un código por SMS para que puedas firmar de forma segura. Para ello, necesitamos que confirmes tu numero de teléfono.</span>
			<div>
				<span>INFORMACIÓN BÁSICA DE PROTECCIÓN DE DATOS</span>
				<p>
					El empleo de este método de firma implica que en “Pensumo, Pensión por Consumo, S.L.”, como entidad legalmente responsable, tratemos tus datos personales identificativos (nombre, apellidos, número de Documento Nacional de Identidad), y datos de firma de documentación (número de teléfono para firma y código OTP o contraseña de un sólo uso), con la finalidad de gestionar y permitir la firma de la documentación contractual necesaria para la formalización del alta del comercio al que representas como comercio asociado en la Plataforma.<br /><br />
					Tienes derecho a solicitar el acceso, la rectificación, la supresión y otros derechos que te reconozca en cada momento la legislación vigente. Puedes consultar información adicional sobre el tratamiento de tus datos personales, en especial sobre el ejercicio de tus derechos, en el <a href="https://media.ibercaja.net/pensumo/gdpr/comercios-personas-fisicas-contacto_v3.pdf">Documento de Información Adicional de Protección de Datos</a>
				</p>
			</div>

			<div class="info-group">
				<!-- <b
					>Teléfono *<tec-tooltip
						label="Número de teléfono al que quieres que te enviemos el OTP para firmar el contrato"
						position="default"
					>
						<tec-icon name="icon-info"></tec-icon> </tec-tooltip
				></b> -->
				<tec-form-group
					label="Teléfono *"
					tooltip="Número de teléfono al que quieres que te enviemos el código para firmar el contrato"
					[errorMsg]="telefonoError"
				>
					<tec-input
						placeholder="612 345 678"
						[formControl]="telefono"
						[hasError]="telefono.invalid && telefono.touched"
					></tec-input>
				</tec-form-group>
			</div>
			<tec-button
				*ngIf="!phoneValid"
				[label]="'Confirmar teléfono'"
				[type]="'default'"
				(clickEvent)="sendOTPCode()"
				[disabled]="!form.valid"
			></tec-button>
		</tec-tile>
	</ng-container>
	<tec-modal type="confirmation" [isVisible]="showModal" buttonPrimaryLabel="OK" (closeEvent)="closeModal($event)">
		<ng-container body>
			<tec-tag-icon [size]="'default'" [icon]="'icon-check'" [status]="'success'"></tec-tag-icon>
			<div class="body__text">
				<h4>Solicitud de alta enviada correctamente</h4>
				<div *ngIf="!!switchAutorizacion; else noAuthorized" style="display: flex; flex-direction: column;">
					<span style="font-weight: bold;">En los próximos días te enviaremos el contrato para que lo revises y firmes.</span><br />
					<span>Recuerda que, con base en la autorización expresa que has otorgado, trataremos tus datos personales biométricos (trazo, coordenadas y presión) durante el proceso de firma de la documentación contractual necesaria para la formalización del alta del comercio al que representas como comercio asociado en la Plataforma, contribuyendo a incrementar de este modo la fiabilidad de la autenticidad y la seguridad del proceso, así como a evitar situaciones fraudulentas en la contratación.</span>
				</div>
				<ng-template #noAuthorized>
					<span>En los próximos días te enviaremos el contrato para que lo revises y firmes</span>
				</ng-template>
			</div>
		</ng-container>
	</tec-modal>
	<tec-footer-actions>
		<tec-button
			[label]="step === 1 ? 'Volver atrás' : buttonLabel"
			[type]="'secondary'"
			(click)="buttonAction(step === 1 ? 1 : step - 1)"
		></tec-button>
		<tec-button
			[label]="'Enviar solicitud'"
			[type]="'default'"
			(click)="sendInformationEmail()"
			[disabled]="enableSendInformation || isLoading"
		></tec-button>
	</tec-footer-actions>
</tec-confirmation-layout>
